/* Device capability hint — browsing is available everywhere. Keyboard-based experiment
 * sessions still need a desktop/laptop; this must never gate access to the whole app.
 *
 * "Desktop" = NOT (a mobile user-agent) and NOT (touch-primary with no hover). A touchscreen
 * laptop still passes, because it also reports a fine pointer / hover. */
export function isDesktop() {
  if (typeof window === "undefined") return true;
  try {
    const ua = /Mobi|Android|iPhone|iPad|iPod|Windows Phone|BlackBerry|Opera Mini|IEMobile/i.test(navigator.userAgent || "");
    const mq = window.matchMedia;
    const touchOnly = !!mq && mq("(pointer: coarse)").matches && mq("(hover: none)").matches;
    return !(ua || touchOnly);
  } catch { return true; }   // never block on a detection error
}

// Use the browser's native viewport scaling, so fixed-position panels, dialogs and desktop
// media queries all use the same coordinate system. Omitting initial-scale lets mobile
// browsers fit this desktop width in either orientation; pinch zoom remains unrestricted.
// Apply once before rendering, never on resize (which would reset the visitor's zoom).
export function configureMobileViewport() {
  if (isDesktop()) return;
  const viewport = document.querySelector('meta[name="viewport"]');
  if (viewport) viewport.setAttribute('content', 'width=1280, user-scalable=yes');
}
